(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scrolling-text"] && !Shopify.designMode) return;
  try {
    
function scrollText() {
  const show = document.querySelector('.scrolling-text[data-show]')
  const next = show.nextElementSibling || document.querySelector('.scrolling-text:first-child')
  const up = document.querySelector('.scrolling-text[data-up]')
  
  if (up) {
    up.removeAttribute('data-up')
  }
  
  show.removeAttribute('data-show')
  show.setAttribute('data-up', '')
  
  next.setAttribute('data-show', '')
}

setInterval(scrollText, 3000);

  } catch(e) { console.error(e); }
})();
})();
